<!-- 首页-核心技术 -->
<template>
	<div
		class="coreTechnology-warp"
		:class="{ 'is-mobile-layout': isMobileLayout }"
	>
		<div class="title">
			<span class="title-text">核心技术</span>
		</div>
		<div class="coreTechnology-list" ref="techList">
			<div class="tech-card" v-for="item in techList" :key="item.id">
				<div class="tech-card-body">
					<div class="tech-card-name">{{ item.name }}</div>
					<ul class="tech-card-features">
						<li v-for="(feat, i) in item.features" :key="i">
							<span class="feature-check" aria-hidden="true">
								<svg
									class="feature-check-icon"
									viewBox="0 0 12 12"
									xmlns="http://www.w3.org/2000/svg"
								>
									<path
										d="M2.25 6.15L4.85 8.7L9.75 3.3"
										fill="none"
										stroke="currentColor"
										stroke-width="1.6"
										stroke-linecap="round"
										stroke-linejoin="round"
									/>
								</svg>
							</span>
							<span class="feature-text">{{ feat }}</span>
						</li>
					</ul>
				</div>
				<!-- 装饰图标：绝对定位，不参与文档流，不影响卡片高度/排版 -->
				<div class="tech-card-icon" aria-hidden="true">
					<img v-lazy="item.icon" :alt="item.name" />
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { getHomeCoreTechnologyList } from '@/network/home/index'
export default {
	name: 'CoreTechnology',
	data() {
		return {
			techList: [],
			isMobileLayout: false,
		}
	},
	created() {
		this._mql = null
	},
	computed: {
		isMobileEnd() {
			return this.$store.state.isMobileEnd
		},
	},
	mounted() {
		this._initMobileLayout()
		this._getHomeCoreTechnologyList()
	},
	beforeDestroy() {
		if (this._mql) {
			if (this._mql.removeEventListener) {
				this._mql.removeEventListener('change', this._onMqlChange)
			} else if (this._mql.removeListener) {
				this._mql.removeListener(this._onMqlChange)
			}
			this._mql = null
		}
	},
	methods: {
		/** 以视口宽度为准（兼容 DevTools 窄屏），不依赖 screen.width */
		_initMobileLayout() {
			if (typeof window === 'undefined' || !window.matchMedia) {
				this.isMobileLayout =
					this.isMobileEnd ||
					(window.innerWidth && window.innerWidth <= 768)
				return
			}
			this._mql = window.matchMedia('(max-width: 768px)')
			this._onMqlChange = (e) => {
				this.isMobileLayout = !!(e && e.matches)
			}
			this.isMobileLayout = !!this._mql.matches
			if (this._mql.addEventListener) {
				this._mql.addEventListener('change', this._onMqlChange)
			} else if (this._mql.addListener) {
				this._mql.addListener(this._onMqlChange)
			}
		},
		_resolveIcon(icon) {
			if (!icon) return ''
			// require() 本地资源 / 绝对地址：直接使用，勿拼 API baseUrl
			// publicPath 为 './' 时，打包结果形如 ./img/xxx.hash.png
			if (
				/^https?:\/\//.test(icon) ||
				/^data:/.test(icon) ||
				/^blob:/.test(icon) ||
				icon.startsWith('./') ||
				icon.startsWith('/img/') ||
				icon.startsWith('/static/') ||
				icon.startsWith('img/')
			) {
				return icon
			}
			return window.baseUrl + icon
		},
		_getHomeCoreTechnologyList() {
			getHomeCoreTechnologyList()
				.then((res) => {
					if (res.data.code == 200) {
						const list = (res.data.data && res.data.data.list) || []
						this.techList = list.slice(0, 6).map((item) => {
							return Object.assign({}, item, {
								icon: this._resolveIcon(item.icon),
								features: Array.isArray(item.features)
									? item.features.slice(0, 3)
									: [],
							})
						})
					}
				})
				.catch((error) => {
					console.error('获取核心技术列表失败', error)
				})
		},
	},
}
</script>

<style lang="scss" scoped>
/* 设计稿：https://js.design/f/eGCLdB?p=nWARn3MmAO&mode=programmer&linkelement=35-502 */
@mixin tech-card-active {
	background-color: #1b6fff;
	color: #ffffff;

	.tech-card-name {
		color: #ffffff;
	}

	.tech-card-features {
		.feature-check {
			background-color: rgba(255, 255, 255, 0.95);

			.feature-check-icon {
				color: #1b6fff;
			}
		}

		.feature-text {
			color: #ffffff;
		}
	}

	.tech-card-icon {
		transform: scale(1.1);
		opacity: 0.3;
	}
}

/* 手机端 2×2 布局（设计稿比例，375 宽基准） */
@mixin mobile-core-tech {
	padding: 0 0 48px 0;
	overflow-x: hidden;
	box-sizing: border-box;

	.title {
		margin-bottom: 24px;

		.title-text {
			font-size: 24px;
			font-weight: 500;
			line-height: 24px;
			color: #333333;
		}
	}

	.coreTechnology-list {
		width: 100%;
		max-width: 100%;
		margin: 0 auto;
		padding: 0 16px;
		box-sizing: border-box;
		display: grid;
		grid-template-columns: repeat(2, minmax(0, 1fr));
		gap: 8px;
	}

	.tech-card {
		width: 100%;
		height: auto;
		min-width: 0;
		min-height: 184px;
		padding: 16px 12px 18px;
		border-radius: 12px;
		background-color: #eff3ff;
		box-sizing: border-box;
		overflow: hidden;

		.tech-card-body {
			position: relative;
			z-index: 2;
			width: 100%;
			max-width: 100%;
			padding-right: 8px;
			box-sizing: border-box;
		}

		.tech-card-name {
			font-size: 16px;
			font-weight: 500;
			line-height: 22px;
			margin-bottom: 8px;
			color: #333333;
			word-break: break-word;
			overflow-wrap: break-word;
		}

		.tech-card-features {
			li {
				margin-bottom: 5px;
				align-items: flex-start;

				&:last-child {
					margin-bottom: 0;
				}
			}

			.feature-check {
				width: 14px;
				height: 14px;
				margin-right: 6px;
				margin-top: 1px;
				background-color: rgba(29, 103, 232, 0.1);

				.feature-check-icon {
					width: 8px;
					height: 8px;
					color: #1d67e8;
				}
			}

			.feature-text {
				font-size: 12px;
				line-height: 15px;
				color: #333333;
				word-break: break-word;
				overflow-wrap: anywhere;
				white-space: normal;
			}
		}

		/* 与 PC 一致：336×184，右偏出 72、下偏出 31 */
		/* 手机端 768：208×114，右偏出 55、下偏出 20 */
		.tech-card-icon {
			position: absolute;
			z-index: 1;
			pointer-events: none;
			opacity: 1;
			transform: none;
			transform-origin: right bottom;
			width: 208px;
			height: 114px;
			right: -55px;
			bottom: -20px;
			max-width: none;
		}

		&:hover {
			@include tech-card-active;
		}
	}
}

.coreTechnology-warp {
	position: relative;
	width: 100%;
	padding: 80px 0 100px;
	/* 底色/圆环底图由 Home.home-tech-solution 统一提供 */
	background-color: transparent;
	box-sizing: border-box;
}

.title {
	position: relative;
	z-index: 1;
	width: 100%;
	margin-bottom: 48px;
	text-align: center;
	.title-text {
		font-size: 36px;
		font-weight: 500;
		color: #333333;
		line-height: 52px;
		display: block;
	}
}

.coreTechnology-list {
	position: relative;
	z-index: 1;
	/* 1920：390×3 + gap 20×2 = 1210 */
	width: 1210px;
	max-width: calc(100% - 48px);
	margin: 0 auto;
	display: grid;
	grid-template-columns: repeat(3, 390px);
	justify-content: center;
	gap: 20px;
	box-sizing: border-box;
}

.tech-card {
	position: relative;
	/* 1920 设计：卡片 390×280 */
	width: 390px;
	height: 280px;
	padding: 28px 24px;
	box-sizing: border-box;
	background-color: #eff3ff;
	border-radius: 16px;
	overflow: hidden;
	cursor: default;
	transition: background-color 0.3s ease, color 0.3s ease;
	color: #333333;
	min-width: 0;

	.tech-card-body {
		position: relative;
		z-index: 2;
		max-width: 100%;
	}

	.tech-card-name {
		font-size: 22px;
		font-weight: 500;
		line-height: 32px;
		margin-bottom: 20px;
		word-break: break-word;
		overflow-wrap: break-word;
		transition: color 0.3s ease;
	}

	.tech-card-features {
		list-style: none;
		margin: 0;
		padding: 0;

		li {
			display: flex;
			align-items: flex-start;
			margin-bottom: 12px;
			min-width: 0;

			&:last-child {
				margin-bottom: 0;
			}
		}

		.feature-check {
			flex-shrink: 0;
			width: 18px;
			height: 18px;
			margin-right: 8px;
			margin-top: 1px;
			border-radius: 50%;
			background-color: rgba(29, 103, 232, 0.1);
			display: inline-flex;
			align-items: center;
			justify-content: center;
			transition: background-color 0.3s ease;

			.feature-check-icon {
				display: block;
				width: 10px;
				height: 10px;
				color: #1d67e8;
				transition: color 0.3s ease;
			}
		}

		.feature-text {
			flex: 1;
			min-width: 0;
			font-size: 14px;
			line-height: 20px;
			color: #333333;
			word-break: break-word;
			overflow-wrap: break-word;
			white-space: normal;
			transition: color 0.3s ease;
		}
	}

	/* 1920 设计：336×184，右偏出 72、下偏出 31，由 overflow:hidden 截取 */
	.tech-card-icon {
		position: absolute;
		z-index: 1;
		pointer-events: none;
		width: 336px;
		height: 184px;
		right: -72px;
		bottom: -31px;
		transition: transform 0.3s ease, opacity 0.3s ease;
		transform-origin: right bottom;

		img {
			display: block;
			width: 100%;
			height: 100%;
			object-fit: contain;
		}
	}

	@media (hover: hover) and (pointer: fine) {
		&:hover {
			@include tech-card-active;
		}
	}
}

@media screen and (max-width: 768px) {
	.coreTechnology-warp {
		@include mobile-core-tech;
	}
}

/* matchMedia 类名双保险 */
.coreTechnology-warp.is-mobile-layout {
	@include mobile-core-tech;
}
</style>
